import { MetricHeaderWrapper } from "../Atom"
import { containedButtonStyles } from "../../../../styles/commonStyles"
import { Box, Button, CircularProgress, Typography } from "@mui/material"
import { useNavigate } from "react-router-dom"
import KeyboardArrowLeftIcon from "@mui/icons-material/KeyboardArrowLeft"
import SingleSelectFilter from "../../Dropdown/Filters/Index"
import { useAppDispatch, useAppSelector } from "../../../redux/hooks"
import { useCallback, useState } from "react"
import {
  setMaevaSelectedClassesNoAll,
  setMaevaSelectedGroupsNoAll,
} from "../../../redux/slices/metricSlice"
import {
  clearDirtyList,
  setBudgetData,
  setSelectedYear,
  setYears,
} from "../../../redux/slices/pnlBudgetSlice"

type Props = {
  saving: any
  saveHandler: any
}

const PNLBudgetHeader = (props: Props) => {
  const { saving, saveHandler } = props

  const navigate = useNavigate()
  const dispatch = useAppDispatch()

  // global states
  const appLoading = useAppSelector((store) => store.app.loading)
  const metricState: any = useAppSelector((store) => store.metric)
  const state = useAppSelector((state) => state.pnlBudget)
  const { maevaGroups, maevaClasses } = metricState
  const maevaSelectedGroups = metricState.maevaSelectedGroupsNoAll
  const maevaSelectedClasses = metricState.maevaSelectedClassesNoAll
  const { selectedYear, dirtyCells, years } = state

  // local states

  // Filter handlers

  const groupChangeHandler = useCallback(
    (_: any, value: any) => {
      // Reducer (metricSlice) cascades: clearing region/practice/class when group changes
      dispatch(setMaevaSelectedGroupsNoAll([value?.props?.value]))
    },
    [dispatch],
  )

  const classChangeHandler = useCallback((_: any, value: any) => {
    dispatch(setMaevaSelectedClassesNoAll([value?.props?.value]))
  }, [])

  const yearChangeHandler = useCallback((_: any, value: any) => {
    dispatch(setSelectedYear(value?.props?.value))
  }, [])

  return (
    <MetricHeaderWrapper>
      <Box sx={{ margin: 0 }}>
        <Typography fontWeight={600} fontSize={"16px"}>
          P&L Budgeting
        </Typography>
        <Box
          sx={{ color: "#888888", cursor: "pointer" }}
          onClick={() => navigate(-1)}
        >
          <KeyboardArrowLeftIcon sx={{ fontSize: "12px" }} /> Back
        </Box>
      </Box>

      <Box
        sx={{
          display: "flex",
          alignItems: "center",
        }}
      >
        <SingleSelectFilter
          key={"p&l-1"}
          disabled={appLoading}
          changeHandler={groupChangeHandler}
          filterData={maevaGroups}
          filterLabel={"Group Name"}
          selectedValue={maevaSelectedGroups?.[0] || null}
          placeHolder={"Select a group"}
        />
        <SingleSelectFilter
          key={"p&l-2"}
          disabled={!maevaSelectedGroups?.length || appLoading}
          changeHandler={classChangeHandler}
          filterData={maevaClasses}
          filterLabel={"Classes"}
          selectedValue={maevaSelectedClasses?.[0] || null}
          placeHolder={"Select a class"}
        />
        <SingleSelectFilter
          key={"p&l-4"}
          disabled={appLoading}
          changeHandler={yearChangeHandler}
          placeHolder={"Select a year"}
          selectedValue={selectedYear || null}
          filterData={years}
          filterLabel={"Year"}
        />
      </Box>

      {selectedYear && maevaSelectedClasses?.length ? (
        <Box
          sx={{
            display: "flex",
            mt: "15px",
            justifyContent: "center",
          }}
        >
          <Button
            variant="contained"
            endIcon={saving && <CircularProgress size="1.2rem" />}
            disabled={!Boolean(dirtyCells.length) || saving}
            sx={{
              ...containedButtonStyles,
              minHeight: "40px",
              px: 1,
              width: "100px",
              fontSize: "14px",
            }}
            onClick={saveHandler}
          >
            {saving ? "Saving" : "Save"}
          </Button>
        </Box>
      ) : (
        <Box />
      )}
    </MetricHeaderWrapper>
  )
}

export default PNLBudgetHeader
